module.exports = __webpack_public_path__ + "static/media/profile-cover.b6f0cb7d.jpg";